// File: app.component.ts
// Author: Joseph M Diaz
// Date: 4/20/2017
// Desc: Root component for the app.
// Other Contributors: Brandon Shreve

import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AppService } from './app.service';
import { CgpIdleService } from './shared/cgp-idle/cgp-idle.service';
import { getEnv } from '../modules/utility';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'cgp-app',
    templateUrl: './app.template.html',
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
    @ViewChild('cgpSidebarContainer', { static: true }) private readonly cgpSidebarContainer: ElementRef;

    public sidenavVisible = false;
    env = '';

    constructor(
        private readonly router: Router,
        public appService: AppService,
        private readonly cgpIdleService: CgpIdleService,
    ) {
        this.appService.appComponent = this;
        this.cgpIdleService.startTimers();
    }

    ngOnInit() {
        const envval = getEnv();
        this.env = getEnv().toLowerCase();
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event) => {
                const sidenavContentContainer = this.cgpSidebarContainer.nativeElement.querySelector('.mat-sidenav-content');
                sidenavContentContainer.scrollTop = 0;
                sidenavContentContainer.scrollLeft = 0;
            });
    }


    @HostListener('window:mousemove')
    onMouseMove() {
        this.cgpIdleService.setIsActive();
    }

    @HostListener('window:mousedown')
    onMouseDown() {
        this.cgpIdleService.setIsActive();
    }

    @HostListener('window:keydown')
    onKeyDown() {
        this.cgpIdleService.setIsActive();
    }
}
